import { AnyObj } from "../moduleRouter/types";
import { Fiber, getInstanceFromNode, isToolsCanUse, workLoop } from "./reactTools";

let weIdMap: AnyObj = {};

// 最大渲染耗时(ms)
const MAX_ACTUAL_DURATION = 10;

// 最大dom树渲染耗时(ms)
const MAX_TREE_BASE_DURATION = 5;

export function fiberHandler(fiber: Fiber) {
  if (!fiber) return null;
  const { actualDuration, treeBaseDuration } = fiber;
  const weId = fiber.memoizedProps?.weId;
  if (weId) {
    if (actualDuration !== undefined && actualDuration >= MAX_ACTUAL_DURATION) {
      weIdMap[weId] = {
        ...(weIdMap[weId] || {}),
        actualDuration,
      };
    };
    if (treeBaseDuration !== undefined && treeBaseDuration >= MAX_TREE_BASE_DURATION) {
      weIdMap[weId] = {
        ...(weIdMap[weId] || {}),
        treeBaseDuration
      }
    };
  }
  return fiber.child;
}

export default function getRenderDuring (dom: Node) {
  weIdMap = {};
  if (!isToolsCanUse) return null;
  const fiberRoot = getInstanceFromNode(dom);
  if (!fiberRoot) return null;
  workLoop(fiberRoot, fiberHandler);
  const weIds = weIdMap;
  weIdMap = {};
  return weIds;
}
